export default function Skills({ skillRef }) {
  return (
    <div id="skills" ref={skillRef}>
      <h2 className="heading">Skills</h2>
      <ul>
        <li>Html</li>
        <li>Css</li>
        <li>Sass</li>
        <li>Post css</li>
        <li>Tailwind css</li>
        <li>JavaScript</li>
        <li>TypeScript</li>
        <li>React</li>
        <li>Vue</li>
        <li>Next.js</li>
        <li>Express</li>
        <li>Git</li>
        <li>Jira</li>
        <li>Confluence</li>
        <li>Figma</li>
        <li>Photoshop</li>
      </ul>
    </div>
  );
}
